export default __webpack_public_path__ + "static/media/move_open.bc02cc37.svg";